import {
    Activity,
    Bell,
    Building2,
    Calendar,
    ChevronDown,
    GraduationCap,
    LayoutDashboard,
    Settings,
    Store,
    Ticket,
    UserCheck,
    Users,
    type LucideIcon,
} from "lucide-react";

export interface MenuItem {
  title: string;
  url: string;
  icon: LucideIcon;
  items?: MenuItem[]; // For nested sub-items
  permissions?: string[]; // Array of required permissions
}

// Menu items matching Enturn College ERP structure
const menuItems: MenuItem[] = [
  {
    title: "Dashboard",
    url: "/",
    icon: LayoutDashboard,
  },
  {
    title: "People",
    url: "#", // Parent item, no direct URL
    icon: Users,
    items: [],
  },
  // {
  //   title: "College",
  //   url: "#",
  //   icon: Building2,
  //   items: [
      // {
      //   title: "College Profile",
      //   url: "/college/profile",
      //   icon: Building2,
      // },
      {
        title: "Department",
        url: "/department",
        icon: Building2,
        permissions: ["department.read"],
      },
    // ],
  // },
  {
    title: "Batches",
    url: "/batches",
    icon: Calendar,
    permissions: ["batch.read"],
  },
  {
    title: "Vendors",
    url: "#", // Parent item
    icon: Store,
    items: [
      {
        title: "Intern Vendors",
        url: "/vendors/intern",
        icon: Store,
      },
      {
        title: "Placement Vendors",
        url: "/vendors/placement",
        icon: Store,
      },
      {
        title: "Soft Skill Vendor",
        url: "/vendors/soft-skill",
        icon: Store,
      },
      {
        title: "Tech Skill Vendors",
        url: "/vendors/tech-skill",
        icon: Store,
      },
    ],
  },
  {
    title: "Activities",
    url: "#", // Parent item
    icon: Activity,
    items: [
      {
        title: "Internships",
        url: "/activities/internships",
        icon: Activity,
      },
      {
        title: "Placement",
        url: "/activities/placement",
        icon: Activity,
        permissions: ["placement.read"],
      },
      {
        title: "Soft Skills",
        url: "/activities/soft-skills",
        icon: Activity,
      },
      {
        title: "Tech Skills",
        url: "/activities/tech-skills",
        icon: Activity,
      },
    ],
  },
  {
    title: "Students",
    url: "/students",
    icon: GraduationCap,
    permissions: ["student.read"],
  },
  {
    title: "Alumni",
    url: "/alumni",
    icon: UserCheck,
  },
  {
    title: "Tickets",
    url: "/tickets",
    icon: Ticket,
  },
  {
    title: "Notifications",
    url: "/notifications",
    icon: Bell,
  },
  {
    title: "Settings",
    url: "/settings",
    icon: Settings,
  },
];

export { ChevronDown }; // Export for use in sidebar component
export default menuItems;
